export default "__VITE_ASSET__CckREuiA__"